<template>
  <div class="hello">
    <template v-show="一览模式">
      <el-checkbox v-model="隐藏的不显示">隐藏的不显示</el-checkbox>
      <el-checkbox v-model="显示的不显示">显示的不显示</el-checkbox>
      <el-checkbox v-model="今年的不显示">今年的不显示</el-checkbox>
    </template>


    <div class="yihang" v-for="(item , i) in gp" :key="i" v-show="一览模式">
      <div style="padding-left: 50px;" v-if="shallShow(item)">

        <span class="hcqStyle5 text">{{ item.ssemuname }} {{ item.ssemuinname }} ({{ item.ssemuinnamecd }}) </span>
        <span class="text" v-if="!今年的不显示">{{ item.zhuizongyear === 今年 ? '' : item.zhuizongyear }}</span>
        <span class="text" v-if="!隐藏的不显示 && item.hiddenkbn"> 隐藏的 </span>
        <br>
        
        <button class="my-button"
         :style="item.zhuizongkbn === '1' ? { 'background-color': '#57f178'} : { 'background-color': '#57f178'}"
         :key="'btn' + i"
         @click="goYL(item)">
         {{ item.zhuizongkbn === '1' ? '编辑' : '作成' }}
        </button>
        <button class="my-button" v-if="item.zhuizongkbn === '1'"
         :style="item.hiddenkbn === '1' ? { 'background-color': '#F56C6C'} : { 'background-color': '#E6A23C'}"
         :key="'hbtn' + i"
         @click="隐藏追踪(item)">
         {{ item.hiddenkbn === '1' ? '不隐藏' : '隱 藏' }}
        </button>
      </div>
    </div>

    <div v-show="!一览模式">
      <div id="ginfo">
        <span class="hcqStyle5 text">{{ ginfo.ssemuname }} {{ ginfo.ssemuinname }} ({{ ginfo.ssemuinnamecd }}) </span>
        <span class="text" v-if="!今年的不显示">{{ ginfo.zhuizongyear === 今年 ? '' : ginfo.zhuizongyear }}</span>
        <span class="text" v-if="!隐藏的不显示 && ginfo.hiddenkbn"> 隐藏的 </span>
        <span class="text" v-if="有可以合入的追蹤"> 有可以合入的追蹤  
        </span>
          <el-button size="mini" type="primary" v-if="有可以合入的追蹤" @click="加入全家桶()">加入全家桶</el-button>    
      </div>

      <div id="gps">
        <el-table :data="gps" stripe style="width: 100%" size="mini"
          highlight-current-row v-if="闪烁Build"
          @current-change="handleCurrentChange" border>


          <el-table-column label="build区分"> 
            <template slot-scope="scope" width="180">
              <el-input v-model="scope.row.buildkind"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="最新版本号"> 
            <template slot-scope="scope" width="180">
              <el-input v-model="scope.row.buildvernew"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="最新build日期"> 
            <template slot-scope="scope" width="180">
              <el-input v-model="scope.row.builddatenew"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="前回build日期"> 
            <template slot-scope="scope" width="180">
              <el-input v-model="scope.row.builddateold"></el-input>
            </template>
          </el-table-column>

          <!-- <el-table-column label="结版区分"> 
            <template slot-scope="scope" width="180">
              <el-checkbox :value="scope.row.endverkbn === '1'"  @change="(v) => {scope.row.endverkbn = v.length}">结版区分</el-checkbox>
            </template>
          </el-table-column> -->

        <el-table-column label="操作" prop="hiddenkbn"
            :filters="[{ text: '隐藏的Build', value: '1' }, { text: '普通的Build', value: null }]"
            :filter-method="(value, row) => { return value == row.hiddenkbn}"
            :filtered-value="filteredBuildvalue" >
            <template slot-scope="scope" width="180">
              <el-button size="mini" :type="scope.row.hiddenkbn === '1' ? 'danger' : 'warning'" @click="隐藏Build(scope.row)">{{ scope.row.hiddenkbn === '1' ? '不隐藏' : '隐 藏' }}</el-button>   
              <!-- <el-button size="mini" type="danger">删除</el-button>      -->
            </template>
          </el-table-column>

        </el-table>

        <el-button size="mini" @click="addgps">追加</el-button>     

      </div>

      <div id="gss">
        <el-table :data="gss" stripe style="width: 100%" size="mini" v-if="闪烁文件" border>

          <!-- <el-table-column label="build区分"> 
            <template slot-scope="scope" width="180">
              <el-input v-model="scope.row.buildkind"></el-input>
            </template>
          </el-table-column> -->

          <el-table-column label="版本号"> 
            <template slot-scope="scope" width="180">
              <el-input v-model="scope.row.buildver"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="git版本号"> 
            <template slot-scope="scope" width="180">
              <el-input v-model="scope.row.buildgitver"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="build日期"> 
            <template slot-scope="scope" width="180">
              <el-input v-model="scope.row.builddate"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="文件名"> 
            <template slot-scope="scope" width="180">
              <div class="drop-area"
                  @dragover.prevent placeholder="将文件拖拽到此区域"
                  @drop.prevent="文件拖入取名字($event, scope.row)">
                <el-input v-model="scope.row.fname"></el-input>
                <!-- <p>将文件拖拽到此区域</p> -->
              </div>
            </template>
          </el-table-column>

          <el-table-column label="文件路径"> 
            <template slot-scope="scope" width="180">
              <el-input v-model="scope.row.fpath"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="操作"  prop="zhuizongsonid"
            :filters="[{ text: '选中的', value: currentRow ? currentRow.zhuizongsonid:null}, { text: '全部的', value: null }]"
            :filter-method="(value, row) => { return value === null || value == row.zhuizongsonid}"
            :filtered-value="filteredFilevalue">
            <template slot-scope="scope" width="180">       
              <el-button size="mini">{{scope.row.zhuizongsonid}}</el-button>
              <el-button size="mini" type="danger" @click="delgss(scope.row)">删除</el-button>     
            </template>
          </el-table-column>
      
        </el-table>

        <el-button size="mini" @click="addgss">追加</el-button>     
      </div>

      <div id="gpURL">
        <el-table :data="gpURL" stripe style="width: 100%" size="mini"
        v-if="闪烁URL"
          border>

          <el-table-column label="URL"> 
            <template slot-scope="scope" width="180">
              {{ scope.row.sswebaddr }}
            </template>
          </el-table-column>
          
          <el-table-column label="操作" prop="hiddenkbn"
            :filters="[{ text: '隐藏的URL', value: '1' }, { text: '普通的URL', value: null }]"
            :filter-method="(value, row) => { return value == row.hiddenkbn}"
            :filtered-value="filteredURlvalue" >
            <template slot-scope="scope" width="180">    
              <el-button size="mini" 
              :title="scope.row.sswebaddr"  class="my-button HH28"
              :style="scope.row.ssdirect ? scope.row.sskbn === '1' ? { 'background-color': '#4CAF50'} : scope.row.sskbn === '2' ? { 'background-color': '#1c83d6'} : { 'background-color': '#58486d'}
              : scope.row.sskbn === '1' ? { 'background-color': '#99c99b'} : scope.row.sskbn === '2' ? { 'background-color': '#92bbdd'} : { 'background-color': '#c2a5e9'}"
              @click="goUrl(scope.row.sswebaddr)">
              {{ scope.row.sskbn === '1' ? '官' : scope.row.sskbn === '2' ? '源' : '他' }}
              </el-button>   
              <el-button size="mini" :type="scope.row.hiddenkbn === '1' ? 'danger' : 'warning'" @click="隐藏链接(scope.row)">{{ scope.row.hiddenkbn === '1' ? '不隐藏' : '隐 藏' }}</el-button>   
              <el-button size="mini" type="danger" @click="URLmoveimdiretly(scope.row, scope, 从URL李斯特里删除1条)">删除</el-button>       
            </template>
          </el-table-column>

        </el-table>

        <el-button size="mini" @click="addgpURL">追加</el-button>     
        <el-button size="mini" @click="从全家桶追加()">从全家桶追加</el-button>  
        <el-button size="mini" type="danger" @click="清空全家桶()">清空全家桶</el-button>  
      </div>

      <br>
      <br>

      <button class="my-button left-mar20"
         :style="ginfo.zhuizongkbn === '1' ? { 'background-color': '#1c83d6'} : { 'background-color': '#57f178'}"

         @click="goCMT(ginfo)">
         {{ ginfo.zhuizongkbn === '1' ? '提交编辑' : '提交作成' }}
      </button>

      <button class="my-button left-mar20"
         :style="{ 'background-color': '#7e7f80'}"

         @click="返回一览(ginfo)">
         返回一览
      </button>

      <button class="my-button left-mar20"
         :style="ginfo.hiddenkbn === '1' ? { 'background-color': '#F56C6C'} : { 'background-color': '#E6A23C'}"

         @click="ginfo.hiddenkbn = ginfo.hiddenkbn === '1' ? null : '1'">
         {{ ginfo.hiddenkbn === '1' ? '不隐藏' : '隱 藏' }}
      </button>

    </div>

    <el-dialog
        title="⚠URL检索"
        :visible.sync="dialogVisible"
        width="95%">
        <span>快乐的URL检索！</span>
        <div>
          <el-form :inline="true" label-width="120px" ref="ruleForm"> 
            <el-form-item label="模拟器内部名" prop="ssemuinnamecd">
                <el-input v-model="ruleForm.ssemuinnamecd"></el-input>
            </el-form-item>
            <el-form-item label="模拟器名" prop="ssemuname">
                <el-input v-model="ruleForm.ssemuname"></el-input>
            </el-form-item>
            <el-form-item label="模拟器分歧名" prop="ssemuinname">
                <el-input v-model="ruleForm.ssemuinname"></el-input>
            </el-form-item>
            <el-checkbox v-model="分歧名空不检索">分歧名空不检索</el-checkbox>
          </el-form>
        </div>

        <div>
          <el-table :data="dialogtableData" stripe style="width: 100%" height="450" size="mini" border>
            <el-table-column prop="ssemuinnamecd" label="SSEMUINNAMECD" width="180"> </el-table-column>
            <el-table-column prop="ssemuname" label="SSEMUNAME" width="180"> </el-table-column>
            <el-table-column prop="ssemuinname" label="SSEMUINNAME" width="180"> </el-table-column>
            <el-table-column prop="sskbn" label="SSKBN"> </el-table-column>
            <el-table-column prop="sswebaddr" label="SSWEBADDR"> </el-table-column>
            <el-table-column prop="ssdirect" label="SSDIRECT"> </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button size="mini" :type="scope.row.hiddenkbn === '1' ? 'danger' : 'warning'" @click="URimdiretly(scope.row, dialog検索);">{{ scope.row.hiddenkbn === '1' ? '不隐藏' : '隱 藏' }}</el-button>
                  <el-button type="primary" @click="dialogVisible = false;dialogOK(scope.row)">确 定</el-button>
                </template>
            </el-table-column>
        </el-table>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false;">取 消</el-button>
            <el-button type="primary" @click="dialog検索()">検 索</el-button>
        </span>
    </el-dialog>

    <el-dialog
        title="🪣这里是全家桶🪣"
        :visible.sync="dialogVisible2"
        width="95%">
        <span>🪣全家桶🪣</span>

        <div>
          <el-table :data="全家桶" stripe style="width: 100%" height="450" size="mini" border>
            <el-table-column prop="ssemuinnamecd" label="SSEMUINNAMECD" width="180"> </el-table-column>
            <el-table-column prop="ssemuname" label="SSEMUNAME" width="180"> </el-table-column>
            <el-table-column prop="ssemuinname" label="SSEMUINNAME" width="180"> </el-table-column>
            <el-table-column prop="sskbn" label="SSKBN"> </el-table-column>
            <el-table-column prop="sswebaddr" label="SSWEBADDR"> </el-table-column>
            <el-table-column prop="ssdirect" label="SSDIRECT"> </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button size="mini" :type="scope.row.hiddenkbn === '1' ? 'danger' : 'warning'"
                    @click="URimdiretly(scope.row, ()=>{scope.row.hiddenkbn = (scope.row.hiddenkbn === '1' ? null : '1')});">
                    {{ scope.row.hiddenkbn === '1' ? '不隐藏' : '隱 藏' }}</el-button>
                  <el-button type="primary" @click="dialogVisible2 = false;dialogOK2(scope.row)">确 定</el-button>
                </template>
            </el-table-column>
        </el-table>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible2 = false;">取 消</el-button>
        </span>
    </el-dialog>
  </div>
  
</template>

<script>
export default {
  name: 'Zhuizong',
  data(){
    return {
      emuOWebtList:[]
      , gp: []
      , gps: []
      , gss: []
      , gpURL: []
      , 全家桶: []
      , ginfo: {}
      , dialogtableData: []
      , 隐藏的不显示: true
      , 显示的不显示: false
      , 今年的不显示: true
      , 今年: new Date().getFullYear() + ''
      , 一览模式: true
      , currentRow: 0
      , dialogVisible: false
      , dialogVisible2: false
      ,  ruleForm: {
        ssemuinnamecd: '',
        ssemuname: '',
        ssemuinname: '',
        }
      , 有可以合入的追蹤: false
      , filteredBuildvalue: [null]
      , filteredFilevalue: [null]
      , filteredURlvalue: [null]
      , 闪烁Build: true
      , 闪烁文件: true
      , 闪烁URL: true
      , 分歧名空不检索: false
      , scrollPositions: {}
      , lastscrollPositionname: 'last'
    };
  },
  props: {
    msg: String
  },
  methods:{
    showAll(){
        let _this = this;
        this.gp = []
        this.$axios.post('/ssBaseS3Controller/zhuizongsys_init.do',)
        .then(res => {
          _this.gp = res.gp.sort((a,b) => {
            if(a.zhuizongkbn != b.zhuizongkbn) return a.zhuizongkbn - b.zhuizongkbn;
            if(a.zhuizongid != b.zhuizongid) return a.zhuizongid - b.zhuizongid;
            if(a.zhuizongyear != b.zhuizongyear) return a.zhuizongyear - b.zhuizongyear;

            if (a.hiddenkbn !== b.hiddenkbn) return a.hiddenkbn ? 1 : -1;

            if(a.ssemuinnamecd != b.ssemuinnamecd) return (a.ssemuinnamecd > b.ssemuinnamecd) ? 1 : -1;
            if(a.ssemuinname != b.ssemuinname) return (a.ssemuinname > b.ssemuinname) ? 1 : -1;
            // if (a.ssemuinnamecd !== b.ssemuinnamecd) return a.ssemuinnamecd.localeCompare(b.ssemuinnamecd);
            // if (a.ssemuinname !== b.ssemuinname) return a.ssemuinname.localeCompare(b.ssemuinname);
          });
          _this.一览模式 = true
          _this.currentRow = 0

          setTimeout(() => {
            _this.复到上次保存的位置();
          }, 100);
        })
    },
    shallShow(item) {
      if(this.隐藏的不显示 && item.hiddenkbn) {
        return false;
      } else if(this.今年的不显示 && item.zhuizongyear === this.今年) {
        return false;
      } if(this.显示的不显示 && !item.hiddenkbn) {
        return false;
      }
      return true;
    },
    /**
     * 進入編輯模式
     */
    goYL(ur){
      let _this = this;
      this.gps = []
      this.gss = []
      this.gpURL = []
      this.ginfo = {}
      this.保存位置();
      this.$axios.post('/ssBaseS3Controller/zhuizongsys_edit_init.do', {...ur,})
      .then(res => {
        _this.gps = res.gps;
        _this.gss = res.gss;
        _this.gpURL = res.gpURL;
        _this.ginfo = ur
        _this.一览模式 = false

        if(ur.zhuizongkbn !== '1'){
          let 已追蹤 = _this.gp.filter(x=> x.zhuizongkbn === '1');
          已追蹤.sort((a,b)=> { return a.zhuizongid - b.zhuizongid })
          
          let maxID = 0;
          for (let index = 0; index < 已追蹤.length; index++) {
            const element = 已追蹤[index];
            if (element.zhuizongid !== maxID ) {
              break;
            } else {
              maxID++
            }             
          }
          _this.ginfo.zhuizongid = maxID;
          _this.ginfo.zhuizongyear = _this.今年

          _this.有可以合入的追蹤 = 已追蹤.filter(x=> x.ssemuinnamecd === ur.ssemuinnamecd? true : false ).length !== 0;
        }


      })
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      this.filteredFilevalue =  [this.currentRow ? this.currentRow.zhuizongsonid : null]
      this.do闪烁文件()
    },
    /**
     * 追加Build
     */
    addgps(){
      let maxSonID = 0;
      for (let index = 0; index < this.gps.length; index++) {
        const element = this.gps[index];
        if (element.zhuizongsonid !== maxSonID ) {
          break;
        } else {
          maxSonID++
        }
      }

      this.gps.push({
          zhuizongid: this.ginfo.zhuizongid
        , zhuizongsonid: maxSonID
        , buildkind: ''
        , hiddenkbn: undefined
        , buildvernew: ''
        , builddatenew: ''
        , builddateold: ''
        , endverkbn: undefined
      })

    },
    /**
     * 追加文件
     */
    addgss(){
      if(!this.currentRow) {
        this.$message({//消息提示框
                  message: '不行啊你这',
                  type: 'error',
                  showClose: true,//是否有关闭按钮
                  duration: 1000 //持续时间
              });
        return
      }
      let maxgSonID = 0;
      let 選中的BUILD = this.gss.filter(x=> x.zhuizongsonid === this.currentRow.zhuizongsonid);
      選中的BUILD.sort((a,b)=> { return a.zhuizonggsonid - b.zhuizonggsonid })

      for (let index = 0; index < 選中的BUILD.length; index++) {
        const element = 選中的BUILD[index];
        if (element.zhuizonggsonid !== maxgSonID ) {
          break;
        } else {
          maxgSonID++
        }
      }
      this.gss.push({
          zhuizongid: this.ginfo.zhuizongid
        , zhuizongsonid: this.currentRow.zhuizongsonid
        , buildkind: undefined
        , zhuizonggsonid: maxgSonID
        , buildver: ''
        , buildgitver: ''
        , builddate: ''
        , fname: ''
        , fpath: '@SPATH@n n'
      })

    },
    dialogOK(row) {
      let cpoy = {...row}
      cpoy.zhuizongid = this.ginfo.zhuizongid
      this.gpURL.push(cpoy)

    },
    dialogOK2(row) {
      let cpoy = {...row}
      cpoy.zhuizongid = this.ginfo.zhuizongid
      this.gpURL.push(cpoy)

    },
    delgss(thisgss) {
      this.gss = this.gss.filter(x=> 
      x.zhuizongid !== thisgss.zhuizongid ||
      x.zhuizongsonid !== thisgss.zhuizongsonid ||
      x.zhuizonggsonid !== thisgss.zhuizonggsonid);
    },
    /**
     * 添加其他URL
     */
    addgpURL(){
      this.ruleForm={
        ssemuinname: this.ginfo.ssemuinname,
        ssemuinnamecd: this.ginfo.ssemuinnamecd,
      }
      this.dialogtableData = [];
      this.dialogVisible = true;
      this.分歧名空不检索 = false;
    },
    /**
     * 保存追踪
     */
    goCMT(ginfo){
      if(!this.gps.length || !this.gss.length || !this.gpURL.length) {
        this.$message({//消息提示框
                  message: '不行啊你这',
                  type: 'error',
                  showClose: true,//是否有关闭按钮
                  duration: 1000 //持续时间
              });
        return
      }

      let upOBJ = {
          zhuizongURLGP: ginfo
        , zhuizongSonList: this.gps
        , zhuizongGSonList: this.gss
        , ssWebaddrList: this.gpURL
      };
      upOBJ.ssWebaddrList.forEach((x)=> {
        x.zhuizongid = this.ginfo.zhuizongid
      })
      let _this = this;
      this.$axios({
                        method: 'post',
                        url: '/ssBaseS3Controller/zhuizongsys_edit_edit.do',
                        data: {
                            'zhuizongDtostr': JSON.stringify(upOBJ)
                        },
                    })
                    // .post('/ssBaseS3Controller/zhuizongsys_edit_edit.do', JSON.stringify(upOBJ))
      .then(() => {  //res是返回结果

            // 还原的
            _this.返回一览()

              _this.$message({//消息提示框
              message: '保存成功',
              type: 'success',
              showClose: true,//是否有关闭按钮
              duration: 1000 //持续时间
          });
      })
      .catch(err => { //请求失败就会捕获报错信息
          console.error('服务器连接失败', err);
      })
    },
    goUrl(ur){
      // console.log(ur);
      window.open(ur, '_blank')
    },
    dialog検索(){
      let _this = this;
      this.dialogtableData = [];
      this.$axios.post(('/ssBaseS3Controller/zhuizongsys_edit_dl1_search' + (this.分歧名空不检索 ? '2' : '') + '.do'), {...this.ruleForm,})
        .then(res => {
          _this.dialogtableData = res.gpURL;
        })
    },
    /**
     * 立即隐藏一条URL
     */
    URimdiretly(obj, doafter) {
      let ur = {
        ssemuinname: obj.ssemuinname,
        ssemuinnamecd: obj.ssemuinnamecd,
        hiddenkbn: obj.hiddenkbn === '1' ? null : '1',
        sswebaddr: obj.sswebaddr
      }
      let _this = this;
      this.$axios.post('/ssBaseS3Controller/zhuizongsys_edit_dl1_hidden.do', ur)
      .then(() => {
            _this.$message({//消息提示框
                message: '保存成功',
                type: 'success',
                showClose: true,//是否有关闭按钮
                duration: 1000 //持续时间
            });
            doafter()
      })
      .catch(err => { //请求失败就会捕获报错信息
          console.error('服务器连接失败', err);
      })
    },
    隐藏链接(row){
      row.hiddenkbn = row.hiddenkbn === '1' ? null : '1';

      this.filteredURlvalue = [null,'1'];
      this.do闪烁URL();
    },
    隐藏Build(row) {
      row.hiddenkbn = row.hiddenkbn === '1' ? null : '1';

      this.filteredBuildvalue = [null,'1'];
      this.do闪烁Build();
    },
    do闪烁Build(){
      this.闪烁Build =false
      let _this = this
      setTimeout(() => {
        _this.闪烁Build =true
      }, 10);
    },
    do闪烁文件(){
      this.闪烁文件 =false
      let _this = this
      setTimeout(() => {
        _this.闪烁文件 =true
      }, 10);
    },
    do闪烁URL(){
      this.闪烁URL =false
      let _this = this
      setTimeout(() => {
        _this.闪烁URL =true
      }, 10);
    },
    返回一览(){
      // this.一览模式 = true
      // this.currentRow = 0
      this.showAll();
    },
    /**
     * 立即移除一条URL
     */
    URLmoveimdiretly(obj, scope ,doafter) {
      let ur = {
        ssemuinname: obj.ssemuinname,
        ssemuinnamecd: obj.ssemuinnamecd,
        hiddenkbn: obj.hiddenkbn === '1' ? '1' : null,
        sswebaddr: obj.sswebaddr,
        zhuizongid: null
      }
      let _this = this;
      this.$axios.post('/ssBaseS3Controller/zhuizongsys_edit_dl1_hidden.do', ur)
      .then(() => {
            _this.$message({//消息提示框
                message: '保存成功',
                type: 'success',
                showClose: true,//是否有关闭按钮
                duration: 1000 //持续时间
            });
            doafter(scope)
      })
      .catch(err => { //请求失败就会捕获报错信息
          console.error('服务器连接失败', err);
      })
    },
    从URL李斯特里删除1条(scope){
      
      this.gpURL = this.gpURL.filter((x,i) => i!==scope.$index)
    
    },
    文件拖入取名字(event, row){
      if(event && event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]) {
        row.fname = event.dataTransfer.files[0].name
      }
    },
    隐藏追踪(item){
      let ur = {...item};
      ur.hiddenkbn = ur.hiddenkbn === '1' ? null : '1';
      let _this = this;
      this.$axios.post('/ssBaseS3Controller/zhuizongsys_hidden.do', ur)
      .then(() => {
            _this.$message({//消息提示框
                message: '保存成功',
                type: 'success',
                showClose: true,//是否有关闭按钮
                duration: 1000 //持续时间
            });
            _this.showAll();
      })
      .catch(err => { //请求失败就会捕获报错信息
          console.error('服务器连接失败', err);
      })
    },
    加入全家桶() {
      this.gpURL.forEach(x=>  this.全家桶.push(x))
    },
    清空全家桶(){
      this.全家桶 = []
    },
    从全家桶追加(){
      this.dialogVisible2 = true
    },
    保存位置(){
      this.saveScrollPosition();
    },
    saveScrollPosition(name) {
      const position = window.scrollY;
      
      // 如果没有提供名称，使用默认名称
      if (!name) {
          name = this.lastscrollPositionname;
      }
      
      // 保存位置
      this.scrollPositions[name] = position;
      
      return position;
    },
    复到上次保存的位置(){
      const lastPosition = this.scrollPositions[this.lastscrollPositionname];
      if (lastPosition) {
          window.scrollTo({
              top: parseInt(lastPosition),
              behavior: 'smooth'
          });
          this.scrollPositions[this.lastscrollPositionname] = 0;
          // showNotification('已恢复到上次保存的位置');
      } else {
          // showNotification('没有找到上次保存的位置', false);
      }
    },
  },
  created:function () {//组件实例化之后执行，页面尚未显示
      this.showAll();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.yihang{
  border: 1px solid #cceff5;
  background: #fafcfd;
  width: 800px;
  margin-bottom: 4px;
  text-align: left;
}


.my-button {
  display: inline-block;
  padding: 12px 24px;
  /* background-color: #4CAF50; */
  background-color: #c2a5e9;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
  transition: box-shadow 0.3s ease-in-out;
  background-color: #57f178
}
 
.my-button:hover, .my-button:focus {
  box-shadow: 0 6px 12px 0 rgba(0,0,0,0.24), 0 6px 20px 0 rgba(0,0,0,0.19);
} 

.hcqStyle5{
  color: transparent;background-color : blue;
  text-shadow : rgba(255,255,255,0.5) 0 5px 6px, rgba(255,255,255,0.2) 1px 3px 3px;
  -webkit-background-clip : text;
}  

  .text-reflect-base{color: palegreen;-webkit-box-reflect:below 10px;}
    .text{
        width: 300px;
        height: 200px;
        /* position: absolute;
        left: 50%;
        margin-left: -150px; */
        background-image: -webkit-linear-gradient(left,blue,#66ffff 10%,#cc00ff 20%,#CC00CC 30%, #CCCCFF 40%, #00FFFF 50%,#CCCCFF 60%,#CC00CC 70%,#CC00FF 80%,#66FFFF 90%,blue 100%);
        -webkit-text-fill-color: transparent;
        -webkit-background-clip: text;
        -webkit-background-size: 200% 100%; 
        -webkit-animation: masked-animation 4s linear infinite;
        font-size: 35px;
    }
    /* @keyframes masked-animation {
        0% {
            background-position: 0  0;
        }
        100% {
            background-position: -100%  0;
        }
    } */

    .HH28 {
      height: 28px;
      padding: 0 24px;
    }

    .left-mar20 {
      margin-left: 20px;
    }

</style>
